import * as fromDatatype from '../datatype-library/index';

export interface bl_webhook_activity_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sent_body: fromDatatype.VarcharDatatypeInterface;
  received_body: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  received_http_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;

}

export class bl_webhook_activity_event_RowClass
  implements bl_webhook_activity_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sent_body: fromDatatype.VarcharDatatypeInterface;
  received_body: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  received_http_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}
